module.exports = __webpack_public_path__ + "static/media/collagen360ºEssence.2a8957d7.png";